var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D9D2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.937 16.5H13.439V14.596H7.44699V13.546L13.187 7.12H14.937V13.238H16.547V14.596H14.937V16.5ZM9.53299 13.238H13.439V8.884H13.327L9.53299 13.126V13.238Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveFour);
export default __webpack_public_path__ + "static/media/inactive-four.db771b0428a84f5e219dccd42b15f54c.svg";
export { ForwardRef as ReactComponent };